import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PublicMobileHeader from "./PublicMobileHeader";
import LocationSelector from "../Common/LocationSelector";

const PublicHeader = () => {
  const navigate = useNavigate();
  const [currentLocation, setCurrentLocation] = useState(() => {
    const storedLocation = localStorage.getItem("userLocation");
    return storedLocation
      ? JSON.parse(storedLocation)
      : {
          city: "",
          state: "",
          latitude: null,
          longitude: null,
          country: "",
          area: "",
          formattedAddress: "",
        };
  });

  return (
    <header className="bg-white shadow-sm py-4 px-6 relative z-50">
      {/* Mobile Header */}
      <div className="block md:hidden">
        <PublicMobileHeader
          currentLocation={currentLocation}
          setCurrentLocation={setCurrentLocation}
        />
      </div>

      <div className="hidden md:block">
        <div className="max-w-screen-xl mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-6">
            <img
              src="/upswap.png"
              alt="UpSway Logo"
              className="h-10 cursor-pointer"
              onClick={() => navigate("/home")}
            />

            <LocationSelector
              initialLocation={currentLocation}
              onLocationSelected={(newLocation) => {
                setCurrentLocation(newLocation);
                localStorage.setItem(
                  "userLocation",
                  JSON.stringify(newLocation)
                );
              }}
              displayClassName="ml-4"
            />
          </div>
          <nav className="hidden md:flex items-center space-x-6 text-sm font-medium text-gray-700 gap-4">
            <button
              onClick={() => navigate("/LocalActivities")}
              className="hover:text-orange-500 transition"
            >
              Browse Activities
            </button>
            <button
              onClick={() => navigate("/PopularDeals")}
              className="hover:text-orange-500 transition"
            >
              Explore Deals
            </button>
            <button
              onClick={() => navigate("/vendor")}
              className="hover:text-orange-500 transition"
            >
              Find Vendors
            </button>
          </nav>

          {/* Auth Buttons */}
          <div className="flex space-x-4">
            <button
              onClick={() => navigate("/createAccount")}
              className="bg-orange-500 text-white font-semibold px-5 py-2 rounded-md hover:bg-orange-600 transition"
            >
              Sign Up
            </button>
            <button
              onClick={() => navigate("/login")}
              className="border border-gray-300 text-gray-700 font-semibold px-5 py-2 rounded-md hover:bg-gray-100 transition"
            >
              Login
            </button>
          </div>
        </div>
       
      </div>
    </header>
  );
};

export default PublicHeader;
